<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-row>
        <a-col :md="2" :sm="24">
          <a-button style="margin-bottom: 10px" type="primary" @click="handleAdd">{{ $t('add') }}</a-button>
        </a-col>
        <!--              <a-col :md="2" :sm="24">-->
        <!--                <a-button style="margin-bottom: 10px" type="primary" @click="handleConfigAdd">Add config</a-button>-->
        <!--              </a-col>-->
        <!--              <a-col :md="2" :sm="24">-->
        <!--                <a-button style="margin-bottom: 10px" type="primary" @click="editProdictConfig">Modify config</a-button>-->
        <!--              </a-col>-->
      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        bordered
      >
        <Dict slot="allowDiferTime" slot-scope="text" :dict-code="DICT_CODE.ALLOW_DIFER_TIME" :value="text" />
        <template slot="allowPrepay" slot-scope="text">
          {{ text == 0 ? $t('notAllow') : $t('allow') }}
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('edit') }}</a>
        </span>
      </a-table>
    </div>
    <installment-product-item-modal
      ref="installmentProductItemModal"
      @ok="modalFormOk"
    ></installment-product-item-modal>
    <prodict-config-modal ref="ProdictConfigModal" @ok="modalFormOk"></prodict-config-modal>
    <prodict-config-list ref="ProdictConfigList"></prodict-config-list>
  </a-card>
</template>

<script>
import { getProductItemList } from '@/webpublicapi/installmentProductManager'
import Dict from '../modules/Dict'
import InstallmentProductItemModal from './modules/InstallmentProductItemModal'
import ProdictConfigModal from './modules/ProdictConfigModal'
import ProdictConfigList from './modules/ProdictConfigList'
export default {
  name: 'installmentProductItemList',
  components: { Dict, InstallmentProductItemModal, ProdictConfigModal, ProdictConfigList },
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
    appSsid: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      title: this.$t('action'),
      visible: false,
      screenWidth: 1200,
      model: {},
      proId: '',
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('periodDuration'),
          align: 'center',
          dataIndex: 'periodDuration',
        },
        {
          title: this.$t('eachPeriodDuration'),
          align: 'center',
          dataIndex: 'duration',
        },
        {
          title: this.$t('maxAmount'),
          align: 'center',
          dataIndex: 'maxAmount',
        },
        {
          title: this.$t('minAmount'),
          align: 'center',
          dataIndex: 'minAmount',
        },
        {
          title: this.$t('incrAmount'),
          align: 'center',
          dataIndex: 'incrAmount',
        },
        {
          title: this.$t('incrQuota'),
          align: 'center',
          dataIndex: 'incrQuota',
        },
        {
          title: this.$t('allowDiferTime'),
          align: 'center',
          dataIndex: 'allowDiferTime',
          scopedSlots: { customRender: 'allowDiferTime' },
        },
        {
          title: this.$t('allowPrepay'),
          align: 'center',
          dataIndex: 'allowPrepay',
          scopedSlots: { customRender: 'allowPrepay' },
        },
        //  {
        //   title: this.$t('serviceFeeRate'),
        //   align: 'center',
        //   dataIndex: 'serviceFeeRate'
        // },
        {
          title: this.$t('diferFeeRate'),
          align: 'center',
          dataIndex: 'diferFeeRate',
        },
        {
          title: this.$t('overdueRate'),
          align: 'center',
          dataIndex: 'overdueRate',
        },
        {
          title: this.$t('dayInterestRate'),
          align: 'center',
          dataIndex: 'dayInterestRate',
        },
        // {
        //   title: this.$t('ivaFee'),
        //   align: 'center',
        //   dataIndex: 'ivaFee',
        // },
        {
          title: this.$t('status'),
          align: 'center',
          dataIndex: 'status',
          customRender: (text) => {
            if (text === '0') {
              return this.$t('invalid')
            } else if (text === '1') {
              return this.$t('valid')
            } else {
              return ''
            }
          },
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  created() {
    this.proId = this.id
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getProductItemList(Object.assign({ productId: this.proId }))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data
          } else {
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },

    handleAdd() {
      this.$refs.installmentProductItemModal.add(this.proId, this.appSsid)
      this.$refs.installmentProductItemModal.title = this.$t('add')
    },
    handleEdit(record) {
      record.allowDiferTime = record.allowDiferTime != undefined && '' + record.allowDiferTime
      this.$refs.installmentProductItemModal.edit(record)
      this.$refs.installmentProductItemModal.title = this.$t('edit')
    },
    handleConfigAdd() {
      this.$refs.ProdictConfigModal.add(this.proId, this.appSsid)
      this.$refs.ProdictConfigModal.title = this.$t('addConfig')
    },
    // Edit dictionary data
    editProdictConfig() {
      this.$refs.ProdictConfigList.edit(this.proId, this.appSsid)
      this.$refs.ProdictConfigList.title = this.$t('editConfig')
    },
    modalFormOk() {
      this.loadData()
    },
  },
  watch: {
    proId(val) {
      this.proId = val
    },
  },
}
</script>
<style scoped></style>
